import { labelByReturnInstructionType, returnInstructionTypes } from '../ReturnInstructionsConfiguration/constants'

export const typeOptions = [
  {
    label: labelByReturnInstructionType[returnInstructionTypes.homePickup],
    value: returnInstructionTypes.homePickup,
  },
  {
    label: labelByReturnInstructionType[returnInstructionTypes.dropoffPoint],
    value: returnInstructionTypes.dropoffPoint,
  },
  {
    label: labelByReturnInstructionType[returnInstructionTypes.storeDropoff],
    value: returnInstructionTypes.storeDropoff,
  },
  {
    label: labelByReturnInstructionType[returnInstructionTypes.shipItYourself],
    value: returnInstructionTypes.shipItYourself,
  },
]
